import { Injectable, ComponentFactoryResolver, ViewContainerRef, Renderer } from '@angular/core';
import { StsBsDialogComponent } from 'app/components/common/sts-bs-dialog/sts-bs-dialog/sts-bs-dialog.component';
import StsLink from '../models/sts-link.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class StsDialogFactoryService {

  constructor(private httpClient: HttpClient,private sanitizer: DomSanitizer) { }

  public setFocusToIframe(frame: HTMLIFrameElement)
  {
    document.getElementById('iframe-loader').style.display = "block";
    frame.contentWindow.focus();
    frame.contentWindow.addEventListener("load", (event) => {document.getElementById('iframe-loader').style.display = "none";});
    frame.contentWindow.addEventListener("DOMContentLoaded", (event) => {document.getElementById('iframe-loader').style.display = "none";});
    frame.contentWindow.addEventListener("ready", (event) => {document.getElementById('iframe-loader').style.display = "none";});
    frame.contentWindow.onload= (event) => {document.getElementById('iframe-loader').style.display = "none";};
  }

  public getHtmlContent(url: string): Observable<string> {
    let requestOptions: Object = { 
      responseType: 'text'
   }
    return this.httpClient.get<string>(url, requestOptions);
  }


  createDialog(compResolver: ComponentFactoryResolver,
    container: ViewContainerRef,
    document: any,
    renderer: Renderer) {

    let links: any = document.querySelectorAll('.ariel-sts-iframe');
    if (!links) {
      return;
    }
    let factory = compResolver.resolveComponentFactory(StsBsDialogComponent);

    for (let link of links) {
      if (link.already) { continue; }
      link.already = true;

      // if component has <ng-content> element for transclusion of inner html,
      // then dynamically created component will not get inner html,
      // since factory knows only components constructor class, and no idea about markup added somewhere as inner html.
      // To transclude, we have to pass inner html nodes explicitly.

      let myNode = document.createElement('span');
      let component = container.createComponent(factory, 0, container.parentInjector, [[myNode]]);
      component.instance.visible = false;
      component.instance.useIFrame = false;
      component.instance.item = new StsLink();
      component.instance.item.title = link.innerHTML;
      component.changeDetectorRef.detectChanges();
      
      container.insert(component.hostView);
      renderer.listen(link, 'click', (event) => {
        event.preventDefault();
        component.instance.htmlContent = null;
        component.instance.visible = true;
        setTimeout(() => {
          document.getElementById('iframe-loader').style.display = "block";
          this.getHtmlContent(link.getAttribute('data-src'))
            .subscribe(
              (response) => {
                document.getElementById('iframe-loader').style.display = "none";
                const bodyRegex = /<body[^>]*>((.|[\n\r])*)<\/body>/im;
                const match = bodyRegex.exec(response);
                if (match && match.length > 1) {
                  component.instance.htmlContent = this.sanitizer.bypassSecurityTrustHtml(match[1]);
                } else {
                  console.error('Body element not found in the HTML string');
                }
              },
              (error) => {
                console.error('Error fetching HTML:', error);
                document.getElementById('iframe-loader').style.display = "none";
              }
            );
        }, 100);
      });
    }
  }  
}
